import { RadioGroupField, useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { useSelector } from 'react-redux';
import { LocationIcon } from 'components/core/location_icon';
import { PHONE_CALL_KINDS } from 'components/event_type_edit/location_v3/constants';
import { ConfigurableItemCard } from 'features/event_type_editor_crud/components/configurable_item_card';
import { countryCodeSelector } from 'selectors/current_user';
import { NoteField } from './note_field';
import { PhoneNumberField } from './phone_number_field';
import { iconSizeCss } from './styles';

// Matches the radio dot's width + gap so this lines up with the option label text above it, not the dot.
const inboundDetailsCss = "i1v7ypud";
export const PhoneCallCard = ({
  fieldNamePrefix,
  subtitle,
  shouldDisableOutbound,
  onDelete,
  onCancel,
  onDone
}) => {
  const defaultCountryCode = useSelector(countryCodeSelector) || '';
  const [{
    value: kind
  }] = useFormField({
    name: `${fieldNamePrefix}.kind`
  });
  const [{
    value: phoneNumber
  }] = useFormField({
    name: `${fieldNamePrefix}.phoneNumber`
  });
  const isInbound = kind === PHONE_CALL_KINDS.inbound;
  const isDoneDisabled = !kind || isInbound && !phoneNumber?.trim();
  const options = [{
    label: I18n.t('publisher.event_type_editor_crud.meeting_details.location.outbound_call_label'),
    description: I18n.t('publisher.event_type_editor_crud.meeting_details.location.outbound_call_description'),
    value: PHONE_CALL_KINDS.outbound,
    disabled: shouldDisableOutbound
  }, {
    label: I18n.t('publisher.event_type_editor_crud.meeting_details.location.inbound_call_label'),
    description: I18n.t('publisher.event_type_editor_crud.meeting_details.location.inbound_call_description'),
    value: PHONE_CALL_KINDS.inbound
  }];
  return <ConfigurableItemCard icon={<LocationIcon useCrudIcons kind={PHONE_CALL_KINDS.outbound} size="x-large" className={iconSizeCss} />} title={I18n.t('publisher.event_type_editor_crud.meeting_details.location.phone_card_title')} subtitle={subtitle} deleteLabel={I18n.t('publisher.action.remove')} onDelete={onDelete} onCancel={onCancel} onDone={onDone} isDoneDisabled={isDoneDisabled}>
      <RadioGroupField name={`${fieldNamePrefix}.kind`} label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.phone_kind_label')} options={options} />
      {isInbound && <div className={inboundDetailsCss}>
          <PhoneNumberField name={`${fieldNamePrefix}.phoneNumber`} label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.phone_number_field_label')} countryCode={defaultCountryCode} numberFormat="E164" required />
          <NoteField fieldNamePrefix={fieldNamePrefix} />
        </div>}
    </ConfigurableItemCard>;
};

require("./phone_call_card.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./phone_call_card.js");